import { AutocompleteChangeReason, Grid } from "@mui/material";
import { Field, FormikErrors } from "formik";
import React, { useEffect } from "react";
import { Inputs } from "../../formInputs";
import { useDispatch, useSelector } from "../../../store";
import { getJobStatuses } from "../../../slices/jobStatus";
import { CustomJobType } from "./QuestionPreview";
import { getJobTypes } from "../../../slices/jobType";
import KeyValue from "../../../types/keyValue";

interface Props {
  i: number;
  values: CustomJobType;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<CustomJobType>>;
}

const JobQuestionSearchView: React.FC<Props> = (props) => {
  const { i, values, setFieldValue } = props;
  const dispatch = useDispatch();
  const { jobTypes } = useSelector((store) => store.jobType);
  const { jobStatuses } = useSelector((store) => store.jobStatus);

  useEffect(() => {
    dispatch(getJobTypes());
    dispatch(getJobStatuses());
  }, [dispatch]);

  return (
    <div>
      <Grid size={12}>
        <Field
          name={`questions.${i}.filterSelectedJobType`}
          label="Job Type"
          component={Inputs.Dropdown}
          options={jobTypes.map((j) => {
            return { id: j.id, value: j.name };
          })}
          required
          staticFilter
          onSelected={(e: any, v: KeyValue, r: AutocompleteChangeReason) => {
            if (r === "removeOption" || r === "clear")
              setFieldValue(`questions.${i}.filterSelectedJobStatuses`, []);
          }}
        />
      </Grid>
      {!!values.questions[i].filterSelectedJobType?.id && (
        <Grid size={12}>
          <Field
            name={`questions.${i}.filterSelectedJobStatuses`}
            component={Inputs.Dropdown}
            options={jobStatuses
              .filter(
                (q) =>
                  values.questions[i].filterSelectedJobType?.id === q.jobTypeId
              )
              .map((j) => {
                return {
                  id: j.id,
                  value: j.name,
                  jobTypeId: j.jobTypeId,
                };
              })}
            staticFilter
            label={"Filter statuses?"}
            multiple
          />
        </Grid>
      )}
    </div>
  );
};

export default JobQuestionSearchView;
